/* eslint-disable import/no-named-as-default */
import { combineReducers } from "@reduxjs/toolkit";
import FichaInfoSlice from "./slices/components/fichaInfo/FichaInfoSlice";
import CalendarSlice from "./slices/components/calendar/CalendarSlice";

const rootReducer = combineReducers({
  FichaInfoSlice,
  CalendarSlice
});

export default rootReducer;
